export default __webpack_public_path__ + "static/media/about-me-mobile.76e01b80.png";